// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__sRnhx","wrapper-nopadding":"wrapper-nopadding__ipdNc","loading":"loading__2VDKh","error":"error__8DXYz","table-loading":"table-loading__3baD0","empty-val":"empty-val__-Of5p","panelheader-tools":"panelheader-tools__iCWw5","propsPanels":"propsPanels__1uk6Q","new":"new__cT69E","marginLm":"marginLm__3eO9p","marginRm":"marginRm__1bzRS","fullWidth":"fullWidth__2xMS6","fullHeight":"fullHeight__VASoc","noData":"noData__24JaG","balogs":"balogs__2xnOh","balance":"balance__2zxTb","label":"label__31IJS","recharge":"recharge__2Dgc2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/Balogs/styles.scss
// module id = 2250
// module chunks = 1